import { TOKEN_EXPIRED_SCREEN } from 'config/config';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  TokenExpiredScreenContainer,
  TokenExpiredScreenIcon,
  TokenExpiredScreenMessage,
  TokenExpiredScreenStatusText,
  TokenExpiredScreenWrapper,
} from './TokenExpiredScreen.styles';

const { statusText, icon, description, contact } = TOKEN_EXPIRED_SCREEN;

const TokenExpiredScreen = memo(() => (
  <TokenExpiredScreenContainer className="token-expired-screen__container">
    <TokenExpiredScreenWrapper>
      <TokenExpiredScreenStatusText className="token-expired-screen__statusText">
        <FormattedMessage id={statusText} />
      </TokenExpiredScreenStatusText>
      <TokenExpiredScreenIcon className="token-expired-screen__icon">
        <img src={icon} alt="icon" />
      </TokenExpiredScreenIcon>
      <TokenExpiredScreenMessage className="token-expired-screen__message_description">
        <FormattedMessage id={description} />
      </TokenExpiredScreenMessage>
      <TokenExpiredScreenMessage className="token-expired-screen__message_contact">
        <FormattedMessage id={contact} />
      </TokenExpiredScreenMessage>
    </TokenExpiredScreenWrapper>
  </TokenExpiredScreenContainer>
));

export default TokenExpiredScreen;
